import { BasicCalls } from '..'

class ResidentialCanteens extends BasicCalls {
    constructor() {
        super()
        this.apiBase = 'residential-canteens'
    }
}

export { ResidentialCanteens }
